import { render, staticRenderFns } from "./TotalAttendees.vue?vue&type=template&id=860da858&"
import script from "./TotalAttendees.vue?vue&type=script&lang=js&"
export * from "./TotalAttendees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports